import { render, staticRenderFns } from "./Wholesaler.vue?vue&type=template&id=c1368df8&scoped=true&"
import script from "./Wholesaler.vue?vue&type=script&lang=js&"
export * from "./Wholesaler.vue?vue&type=script&lang=js&"
import style0 from "./Wholesaler.vue?vue&type=style&index=0&id=c1368df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1368df8",
  null
  
)

export default component.exports